
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type singleVehicleGarageRTRootProps = TemplateRootPropsForTag<'a'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function singleVehicleGarageRT(): TemplateResult<singleVehicleGarageRTRootProps> {
    return _createElement('a', { 'className': 'navPages-action' }, [this.changeButton(function () {
            return _createElement('span', { 'className': 'text cm_changeButton' }, _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-garage' })), this.template === 'active' ? _createElement('span', {
                'className': 'cmTemplate_active',
                'key': '100'
            }, 'Garage') : null, this.template === 'locked' ? _createElement('span', {
                'className': 'cmTemplate_locked',
                'key': '195'
            }, this.vehicleString) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:changeButton"]